<div class="modal"
aria-hidden="true"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':displayStyle}">
  <div class="modal-dialog modal-lg"    role="document">
    
  </div>
</div>